<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
          <span class="fonints">计划单号</span>
          <el-input placeholder="请输入关键词" v-model="conditions.pno" clearable>
          </el-input>
          <span class="fonints">货主名称</span>
          <el-input placeholder="请输入关键词" v-model="conditions.customname" clearable>
          </el-input>
          <span class="fonints">货代名称</span>
          <el-input placeholder="请输入关键词" v-model.trim="conditions.fleetname" clearable>
          </el-input>
          <span class="fonints">船名</span>
          <el-input placeholder="请输入关键词" v-model="conditions.shipname" clearable>
          </el-input>
          <!-- <span class="fonints">流向</span>
          <el-input placeholder="请输入关键词" v-model="conditions.customername" clearable>
          </el-input> -->

        </div>
        <div class="componentSty_content_title_flex_button">
          <button class="buttons" @click="selectlist">查询</button>
        </div>
      </div>
      <div class="componentSty_content_title">
          
          <span class="fonints">流向</span>
          <el-input placeholder="请输入关键词" v-model="conditions.customername" clearable>
          </el-input>

        </div>
      <div class="componentSty_content_table" style="top: 90px;">
        <el-table :data="arrlist.data" style="width: 100%; height: 80%" @sort-change="sortchange" height="80%">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column prop="pno" show-overflow-tooltip :render-header="renderHeader" sortable="custom" label="计划单号">
          </el-table-column>
          <el-table-column prop="customname" show-overflow-tooltip :render-header="renderHeader" label="货主名称">
          </el-table-column>
          <el-table-column prop="agentname" label="代理名称" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="shipname" label="船名" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="goodsname" label="货物名称" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="fleetname" label="代理" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="customername" label="流向" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column label="计划吨数" show-overflow-tooltip :render-header="renderHeader">
            <template v-slot="res">
              <span>{{ res.row.plantons }}</span>
            </template>
          </el-table-column>
          <el-table-column label="完成吨数" show-overflow-tooltip :render-header="renderHeader">
            <template v-slot="res">
              <span>{{ (res.row.sumSullte / 1000).toFixed(2) || "" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="fleetplanstatus" label="后台审核" show-overflow-tooltip :render-header="renderHeader">
            <!-- 0后台审核  1后台不审核 -->
            <template v-slot="res">
              <span v-if="res.row.fleetplanstatus == 0" class="el_spanfontstyle" style="color: #17B6A1">审核</span>
              <span v-if="res.row.fleetplanstatus == 1" class="el_spanfontstyle" style="color: #fe5a24">不审核</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="res">
              <span v-if="res.row.fleetplanstatus == 1" class="iconfont icon-jinyong" @click="checkState(res.row)"></span>
              <span v-if="res.row.fleetplanstatus == 0" class="iconfont icon-qiyong" @click="checkState(res.row)"></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.data && arrlist.data.length">
          <el-pagination :page-size="conditions.limit" :current-page="conditions.page"
            layout="total,prev, pager,next, jumper" :total="arrlist.Count" @current-change="getarrlist">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "计划管理" }, { name: "代理计划" }],
      conditions: {},
      arrlist: [],
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: {
          page: 1,
          limit: 20,
          sidx: "pno", //排序字段
          order: "desc", //排序方式
        },
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      sidx: "pno", //排序字段
      order: "desc", //排序方式
    };
    this.getarrlist();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getarrlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      this.filterInfo(this.selectitem);
      const { data } = await this.$http(
        "api1",
        "/fleet/planfleetmessage/fleetPlan",
        "post",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data;
    },
    checkState(row) {
      antiShake(async (_) => {
        if (row.fleetplanstatus == 1) {
          const { data } = await this.$http(
            "api1",
            "/fleet/planfleetmessage/backstageAudit",
            "post",
            { ids: [row.planfleetid] }
          );
          if (!data || data.msg != "success")
            return this.$message.error("修改失败");
          row.fleetplanstatus = 0;
          this.$message.success("已修改为审核");
        } else {
          const { data } = await this.$http(
            "api1",
            "/fleet/planfleetmessage/backstageNotAudit",
            "post",
            { ids: [row.planfleetid] }
          );
          if (!data || data.msg != "success")
            return this.$message.error("修改失败");
          row.fleetplanstatus = 1;
          this.$message.success("已修改为不审核");
        }
      });
    },
    filterInfo(obj) {
      for (var i in obj) {
        if (obj[i] == "") delete obj[i];
      }
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getarrlist();
      });
    },
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getarrlist();
    },
    jumpParticulars(res) {
      window.sessionStorage.setItem(
        "infoid",
        JSON.stringify({ id: res.id, pno: res.pno, sumSullte: res.sumSullte })
      );
      this.$router.push({ name: "planlistParticulars" });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>